import {E2xService} from '../../services';
import {WaitListState} from '../../models';
import {AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {ChangeDetectorRef, Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-waitlist',
  templateUrl: './waitlist.component.html',
  styleUrls: ['./waitlist.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WaitlistComponent implements OnInit {
  public waitListForm: FormGroup;
  private states: WaitListState[] = [];
  public stateDropdownValues: WaitListState[] = [];
  public displaySuccessScreen = false;
  public isLoading = false;

  constructor(private fb: FormBuilder, private e2xService: E2xService, private cdr: ChangeDetectorRef) {
  }

  public get isFormComplete(): boolean {
    return this.waitListForm.valid;
  }

  ngOnInit() {
    this.waitListForm = this.fb.group({
      companyName: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', [Validators.required]],
      companyPointOfContactName: ['', Validators.required],
      companyPointOfContactEmailAddress: ['', [Validators.required, Validators.email]],
      companyPointOfContactTitle: [''],
    });

    this.fetchListOfStates();
  }

  public fetchListOfStates(): void {
    this.e2xService.getWaitListStates().subscribe(res => {
      this.states = res.data.states;
      this.waitListForm.get('state').setValidators(this.dropdownValueValidator(this.states));
      this.cdr.detectChanges();
    });
  }

  public search(event: { query: string }): void {
    this.stateDropdownValues = event.query
      ? this.states.filter(x => x.name.toLocaleLowerCase().startsWith(event.query.toLowerCase()))
      : this.states;
  }

  public handleClear() {
    this.fetchListOfStates();
  }

  public joinWaitList(): void {
    this.isLoading = true;
    this.displaySuccessScreen = true;

    this.e2xService.saveToWaitList(this.waitListForm.getRawValue()).subscribe(res => {
      this.isLoading = false;
      this.waitListForm.reset();
    });
  }

  private dropdownValueValidator(validOptions: WaitListState[]): ValidatorFn {
    return (control: AbstractControl) => {
      const isValid = validOptions.some(option => option.name === control.value.name);
      return isValid ? null : {invalidDropdownValue: true};
    };
  }
}
